import { render, staticRenderFns } from "./TherapistDashModalAddMilageReimbursement.vue?vue&type=template&id=56a49f51&scoped=true"
import script from "./TherapistDashModalAddMilageReimbursement.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalAddMilageReimbursement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a49f51",
  null
  
)

export default component.exports